module.exports = __webpack_public_path__ + "img/language_model.38abe4a2.jpg";